import { Injectable } from '@angular/core';
import { selectListEntities } from '@epicuro-next/state/list-entities';
import { isNonNullish } from '@epicuro-next/utilities';
import { select, Store } from '@ngrx/store';
import { map, switchMap } from 'rxjs/operators';

import { selectLookBookEntity } from './lookbook-entities.selectors';

@Injectable()
export class LookBookEntitiesService {
  constructor(private store: Store) {}

  /**
   * Returns shared observable of lookbook listentities
   * by combining lookbook-entities state and list-entities-state
   * @param lookBookId Relevant lookbook id for lookup in entities
   */
  public getLookBookListEntities$(lookBookId: string) {
    return this.store.pipe(
      select(selectLookBookEntity(lookBookId)),
      switchMap((lookBook) => {
        const listIds =
          lookBook?.lookBook?.items.map((item) => item.productListId) ?? [];
        return this.store.pipe(
          select(selectListEntities, listIds),
          map((entities) =>
            listIds.map((listId) => entities[listId]).filter(isNonNullish),
          ),
        );
      }),
    );
  }
}
